import React from 'react';
import eyLogo from '../img/ey_logo.png';
import { Link } from "react-router-dom";
import { NavLink } from 'react-router-dom';

import hasACL from '../util/hasACL';
import hasMultiCobrands from '../util/hasMultiCobrands';

function Navbar(props) {
	return localStorage.getItem('userData') ? (
		<header id="header">
			<div className="header-body">
				<nav className="navbar navbar-expand-lg navbar-dark bg-transparent">
					<div className={(JSON.parse(localStorage.getItem('userData')) && JSON.parse(localStorage.getItem('userData')).userType && JSON.parse(localStorage.getItem('userData')).userType === "yca") ? "container yca" : "container"}>
						<div className="navbar-brand" href="#">
							<Link className="nav-link" to="/">
   								<img src={eyLogo} width="140" height="50" className="d-inline-block" alt="" />
								   {JSON.parse(localStorage.getItem('userData')) && JSON.parse(localStorage.getItem('userData')).userType && JSON.parse(localStorage.getItem('userData')).userType === "yca" &&
								   	<span className="logo-text">Credit Accelerator</span>
								   }
								   {JSON.parse(localStorage.getItem('userData')) && JSON.parse(localStorage.getItem('userData')).userType && JSON.parse(localStorage.getItem('userData')).userType === "snapshot" &&
								   	<span className="logo-text">SNAPSHOT</span>
									}
							</Link>
  						</div>
						<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						<div className="collapse navbar-collapse" id="navbarNavAltMarkup">
							{ props.displayLinks &&
								<nav className="navbar">
									<ProtectedNavLink acl="VW_SNP_MGMT" to={'/applications/' + localStorage.getItem('cobrandId')} text="Applications" />
									<ProtectedNavLink acl="VW_RPT_MGMT" to={'/reports/' + localStorage.getItem('cobrandId')} text="Reports" />
									<ProtectedNavLink acl="VW_CFG" to={'/config/' + localStorage.getItem('cobrandId')} text="Config" />
									<ProtectedNavLink acl="VW_WHK" to={'/webhooks/' + localStorage.getItem('cobrandId')} text="Webhooks" />
									<ProtectedNavLink acl="VW_USER_MGMT" to={'/userMgmt/' + localStorage.getItem('cobrandId')} text="Admin" />
									<ProtectedNavLink acl="VW_BWR_MGMT" to={'/applicantMgmt/' + localStorage.getItem('cobrandId')} text="Applicants" />
								</nav>
							}
							<ul className="navbar-nav color-blue ml-auto">
								<li className="nav-item dropdown" style={dropdownStyle}>
									<a className="nav-link dropdown-toggle ellip-name" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										<i className="fas fa-user fa-1x"></i> { JSON.parse(localStorage.getItem('userData')).fname } { JSON.parse(localStorage.getItem('userData')).lname }
									</a>
									<div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
										{ props.flow !== "restricted" &&
											<React.Fragment>
												<ProtectedNavLink acl="VW_PROFILE_MGMT" activeClassName="" className="dropdown-item" to={'/changePassword'} text="Change Password" />
												<div className="dropdown-divider"></div>
											</React.Fragment>
										}
										<Link className="dropdown-item" to="/logout">Logout</Link>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</div>
		</header>
	) : (
		<header id="header">
			<div className="header-body">
				<nav className="navbar navbar-expand-lg navbar-dark bg-transparent">
					<div className="container">
						<div className="navbar-brand" href="#">
							<Link className="nav-link" to="/">
								<img src={eyLogo} width="140" height="50" className="d-inline-block" alt="" />
								<span className="logo-text">SNAPSHOT</span>
							</Link>
						</div>
					</div>
				</nav>
			</div>
		</header>
	);
}

function ProtectedNavLink({ component: Component, ...rest }) {
	return (
		hasACL(rest.acl) &&
			<NavLink exact activeClassName={rest.activeClassName === "" ? rest.activeClassName : 'navbar_link--active'} className={rest.className ? rest.className : 'navbar_link'} to={rest.to}>
				{ rest.text }
			</NavLink>
	);
}

const dropdownStyle = {
	cursor: 'pointer'
}

export default Navbar;
